import type { ThemePalette } from '@angular/material/core';
import type { ModalTitleIcons } from '../enums/modal-title-icons.enum';
import type { ModalActions } from '../types/modal-actions.type';

export interface ModalData {
    footerButtons?: ModalAction[];
    footerBackgroundColor?: string;
    titleLocalizationKey?: string;
    showCloseButton: boolean;
    titleIcon: ModalTitleIcons;
    content: ModalContent;
    shouldCloseDialog?: boolean;
    backgroundColor?: string;
    width?: string;
    minHeight?: string;
    textSize?: string;
}
interface ModalContent {
    // written in order of visibility in dialog
    icon?: string;
    text: string[];
    descriptiveText?: string;
    button?: string;
    textBelowButton?: string;
}

interface ModalAction {
    localizationKey: string;
    action: ModalActions;
    buttonColor: ThemePalette | 'basic' | string;
    disabled?: boolean;
}
